


import React from 'react'
import { GRID_IMAGE, IMAGE, METRO, MOVIE_PERFORMANCES, TEXT, TITLE } from '../../../constants/itemTypes'
import ListItemImageContainer from '../../DragAndDropItems/cont/ListItemImageContainer'
import ListItemTextContainer from '../../DragAndDropItems/cont/ListItemTextContainer'
import ListItemMoviePerformancesContainer from '../../DragAndDropItems/cont/ListItemMoviePerformancesContainer'
import ListItemGridImageContainer from '../../DragAndDropItems/cont/ListItemGridImageContainer'
import Translation from '../../Translation/cont/Translation'



const FlyerDropSwitch = ({
    itemId,
    itemData,
    basicUrl,
    isSelected=false,
    canEdit,
    canDelete=false,
    deleteItem=false
}) => {
    if(!itemData) {
        return ''
    }

    const { id, type } = itemData
    const pathnameEdit =  canEdit ? `${basicUrl}/${type}/${id}` : false
    const onDeleteItem = canDelete && deleteItem ? () => deleteItem(type, itemId) : false

    const itemTypeTransId = {
        [MOVIE_PERFORMANCES]: 'print_flyer_movie_performances_element',
        [GRID_IMAGE]: 'print_flyer_element_image_grid',
        [METRO]: 'print_flyer_metro_element',
        [IMAGE]: 'print_flyer_image_element',
        [TEXT]: 'print_flyer_text_element',
        [TITLE]: 'print_flyer_heading_element',
    }


    return (
        <div>
            <h3 className="text-regular">
                <Translation id={itemTypeTransId[type]}/>
            </h3>

            {IMAGE === type || METRO === type ? (
                <ListItemImageContainer
                    imgKey={IMAGE === type ? 'payload' : 'image'}
                    itemType={type}
                    itemData={itemData.itemData}
                    isSelected={isSelected}
                    pathnameEdit={pathnameEdit}
                    onDelete={onDeleteItem}
                />
            ) : TEXT === type || TITLE === type ?(
                <ListItemTextContainer
                    textKey='payload'
                    itemType={type}
                    itemData={itemData.itemData}
                    isSelected={isSelected}
                    pathnameEdit={pathnameEdit}
                    onDelete={onDeleteItem}
                />
            ) : MOVIE_PERFORMANCES === type ? (
                <ListItemMoviePerformancesContainer
                    itemType={type}
                    itemData={itemData.itemData}
                    isSelected={isSelected}
                    onDelete={onDeleteItem}

                />
            ) : GRID_IMAGE === type ? (
                <ListItemGridImageContainer
                    itemData={itemData.itemData}
                    pathnameEdit={pathnameEdit}
                    onDelete={onDeleteItem}
                />
            ) : ('')}
         </div>
    )
}

export default FlyerDropSwitch